import pickBy from 'lodash/pickBy'
import { useQuery } from 'react-query'
import { fetchPages, deserializePage } from 'supporticon/api/pages'

export const usePages = (params, options) => {
  const { deserializeMethod, refetchInterval, staleTime = 30000 } = options

  return useQuery(
    ['pages', pickBy({
      allPages: params.allPages,
      campaign: params.campaign,
      charity: params.charity,
      event: params.event,
      ids: params.ids,
      limit: params.limit,
      q: params.q,
      userPages: params.userPages
    })],
    () =>
      fetchPages(params)
        .then(results => results.map(deserializeMethod || deserializePage)),
    {
      refetchInterval,
      staleTime
    }
  )
}

export default usePages
